import { PromotionalType } from './__autogenerated__/types/PromotionalType';

/**
 * Maps short codes to full PromotionalType IDs
 * Format: 'CODE' -> PromotionalType.VALUE
 */
export const shortCodeToPromoType: Record<string, PromotionalType> = {
  // Bloomingdale's
  BLTOP: PromotionalType.BLOOMINGDALES_TOP_OF_LIST_TIER,
  BLLOY: PromotionalType.BLOOMINGDALES_LOYALIST_TIER,

  // Bank of America Preferred Rewards
  BOAG: PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD,
  BOAP: PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM,
  BOAPH: PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS,
  BOADH: PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_DIAMOND_HONORS,
  BOASB: PromotionalType.REQUIRE_BANK_OF_AMERICA_SMALL_BUSINESS_ACCOUNT,

  // Amazon Prime
  PRIME: PromotionalType.PRIME_MEMBERSHIP,

  // Upromise
  UPROM: PromotionalType.UPROMISE_COLLEGE_SAVINGS_PLAN,

  // US Bank Smartly
  USB1: PromotionalType.US_BANK_SMARTLY_TIER_1,
  USB2: PromotionalType.US_BANK_SMARTLY_TIER_2,
  USB3: PromotionalType.US_BANK_SMARTLY_TIER_3,

  // Bilt
  BLYFT: PromotionalType.BILT_CONNECT_TO_LYFT,
  BLRNT: PromotionalType.BILT_RENT_DAY,
  BL25: PromotionalType.BILT_SPEND_RATIO_25,
  BL50: PromotionalType.BILT_SPEND_RATIO_50,
  BL75: PromotionalType.BILT_SPEND_RATIO_75,
  BL100: PromotionalType.BILT_SPEND_RATIO_100,

  // PenFed
  PFHA: PromotionalType.PENFED_HONORS_ADVANTAGE,
};

/**
 * Reverse lookup map: PromotionalType -> short code
 */
export const promoTypeToShortCode: Record<PromotionalType, string> =
  Object.fromEntries(
    Object.entries(shortCodeToPromoType).map(([code, promoType]) => [
      promoType,
      code,
    ])
  ) as Record<PromotionalType, string>;

/**
 * Encodes a PromotionalType to its short code, or returns the full ID if no short code exists
 */
export function promoTypeToShort(promoType: PromotionalType): string {
  return promoTypeToShortCode[promoType] || promoType;
}

/**
 * Decodes a short code to its full PromotionalType, or returns the input if it's already a full ID
 */
export function shortToPromoType(input: string): PromotionalType {
  return shortCodeToPromoType[input] || (input as PromotionalType);
}
